import lazyComponent from '../../../utils/lazyComponent';

const LazyLoginDialog = lazyComponent(() => import('./LoginDialog'));

export default LazyLoginDialog;
